import { useGrid, useScreen } from 'vue-screen';

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      breakpointsOrder: ['xs', 'sm', 'md', 'lg', 'xl'],
      screen: useScreen(),
      grid: useGrid({
        xs: 320,
        sm: 568,
        md: 1024,
        lg: 1238,
        xl: 1440,
      })
    }
  }
});
